<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset="">
                  
                    <h5 class="m-0 "><a class="fw-medium d-flex align-items-center text-black gap-2" (click)="goBack()"> <mat-icon class="back-arrow text-black"  aria-label="Example home icon" fontIcon="west"></mat-icon>{{'BACK' | translate }}</a></h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4 fw-light">{{'CHANGE_PASSWORD' | translate }}</h2>
                    <form class="login-form" [formGroup]="changePasswordForm" (ngSubmit)="form.form.valid" #form="ngForm">
                        <!-- <div class="">
                            <mat-label>Enter Current Password</mat-label>
                            <input matInput class="w-100 form-control" placeholder="Enter Current Password" formControlName="currentPassword" type="{{passwordinputType}}" autocomplete="off">
                            <div (click)="changeInputType(passwordinputType,'changepassword')">
                                <mat-icon *ngIf="passwordinputType == 'password'" aria-hidden="false"
                                    aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                <mat-icon *ngIf="passwordinputType == 'text'" aria-hidden="false" aria-label="Visibility On"
                                    fontIcon="visibility_on"></mat-icon>
                            </div>
                        </div>
                        <mat-error class="text-danger"
                        *ngIf="(form.submitted || changePasswordForm.get('currentPassword')?.touched) &&
                               changePasswordForm.get('currentPassword')?.hasError('pattern')">
                        Password must be one upper case, one lower case, one number, one special character and minimum 8 characters
                      </mat-error> 
                      <mat-error class="text-danger"
                        *ngIf="(form.submitted || changePasswordForm.get('currentPassword')?.touched) &&
                               changePasswordForm.get('currentPassword')?.hasError('required')">
                               Current Password is required
                      </mat-error>  -->
                      <div class="mb-3">
                        <mat-label>{{'ENTER_CURRENT_PASSWORD' | translate }}</mat-label>
                        <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'ENTER_CURRENT_PASSWORD' | translate" formControlName="currentPassword" type="{{currentPasswordInputType}}" autocomplete="off">
                                <div (click)="changeInputType(currentPasswordInputType,'changepassword')">
                                    <mat-icon *ngIf="currentPasswordInputType == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="currentPasswordInputType == 'text'" aria-hidden="false" aria-label="Visibility On"
                                        fontIcon="visibility_on"></mat-icon>
                                </div>
                                <mat-error class="text-danger"
                                *ngIf="(form.submitted || changePasswordForm.get('currentPassword')?.touched) &&
                                        changePasswordForm.get('currentPassword')?.hasError('pattern')">
                                {{'PASSWORD_VALIDATION_MSG' | translate }}
                              </mat-error> 
                              <mat-error class="text-danger"
                                    *ngIf="(form.submitted || changePasswordForm.get('currentPassword')?.touched) &&
                                            changePasswordForm.get('currentPassword')?.hasError('required')">
                                    {{'CURRENT_PASSWORD_REQUIRED_MSG' | translate }}
                            </mat-error>
                        </div>
                    </div>
                        <div class="mb-3">
                            <mat-label>{{'NEW_PASSWORD' | translate }} </mat-label>
                            <div class="position-relative">
                                    <input matInput class="w-100 form-control" [placeholder]="'NEW_PAASSWORD_PLACEHOLDER' | translate" formControlName="newPassword" type="{{passwordinputType}}" autocomplete="off">
                                    <div (click)="changeInputType(passwordinputType,'password')">
                                        <mat-icon *ngIf="passwordinputType == 'password'" aria-hidden="false"
                                            aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                        <mat-icon *ngIf="passwordinputType == 'text'" aria-hidden="false" aria-label="Visibility On"
                                            fontIcon="visibility_on"></mat-icon>
                                    </div>
                                    <mat-error class="text-danger"
                                    *ngIf="(form.submitted || changePasswordForm.get('newPassword')?.touched) &&
                                           changePasswordForm.get('newPassword')?.hasError('pattern')">
                                    {{'PASSWORD_VALIDATION_MSG' | translate }}
                                  </mat-error> 
                                  <mat-error class="text-danger"
                                    *ngIf="(form.submitted || changePasswordForm.get('newPassword')?.touched) &&
                                        changePasswordForm.get('newPassword')?.hasError('required')">
                                        {{'NEW_PAASSWORD_REQUIRED_MSG' | translate }}
                                </mat-error>
                                    <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility_off"></mat-icon> -->
                                    <!-- <mat-error class="text-danger"
                                        *ngIf="(form.submitted || signUpQuestion.get('password')?.touched) && signUpQuestion.controls['password'].errors?.['required']">
                                        Password is required
                                    </mat-error>
                                    <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpQuestion.get('password')?.touched) &&
                                           signUpQuestion.get('password')?.hasError('pattern')">
                                    Password must be one upper case, one lower case, one number, one special character and minimum 8 characters
                                  </mat-error> -->
                            </div>
                        </div>

                        <div class="mb-3">
                            <mat-label>{{'CONFIRM_PASSWORD' | translate }} </mat-label>
                            <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'CONFIRM_PASSWORD_PLACEHOLDER' | translate" formControlName="confirmPassword" type="{{confirmPasswordinputTypes}}">
                                <div (click)="changeInputType(confirmPasswordinputTypes,'confirmPassword')">
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'text'" aria-hidden="false" aria-label="Visibility On"
                                        fontIcon="visibility_on"></mat-icon>
                                </div>
                                <mat-error class="text-danger"
                                *ngIf="(form.submitted || changePasswordForm.get('confirmPassword')?.touched) &&
                                       changePasswordForm.get('confirmPassword')?.hasError('pattern')">
                               {{'PASSWORD_VALIDATION_MSG' | translate }}
                              </mat-error> 
                              <mat-error class="text-danger"
                              *ngIf="(form.submitted || changePasswordForm.get('confirmPassword')?.touched) && 
                              changePasswordForm.get('newPassword')?.value !== changePasswordForm.get('confirmPassword')?.value">
                              {{'PASSWORD_NOT_MATCHED_MSG' | translate }}
                            </mat-error>
                            <mat-error class="text-danger"
                            *ngIf="(form.submitted || changePasswordForm.get('confirmPassword')?.touched) &&
                                changePasswordForm.get('confirmPassword')?.hasError('required')">
                                {{'CONFIRM_PASSWORD_REQUIRED_MSG' | translate }}
                        </mat-error>
                                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility"></mat-icon> -->
                                <!-- <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpQuestion.get('confirmPassword')?.touched) && signUpQuestion.controls['confirmPassword'].errors?.['required']">
                                ConfirmPassword is required
                                </mat-error> -->
                            </div>
                        </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onChangePasssword()">{{'CHANGE_YOUR_PASSWORD' | translate }}</button>
                    </form>
                </div>
            </div>
         
        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height" [ngClass]="userTypeId === 3 ? 'firmChangePassword-bg' : 'changePassword-bg'">
              <p>&nbsp;</p>
            </div>
        
        </div>
    </div>
</div>

